import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const BestOnlineStoreDevelopersInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Best Online Store Developers in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Launch Your E-commerce Success</Subheading>}
        heading={
          <Heading>
            Best <span tw="text-primary-500">Online Store Developers</span> in
            Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset leads as one of the best online store developers in
            **Al Barsha**, delivering tailored, high-performance e-commerce
            solutions to elevate your business. Start your online journey with
            us.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1612469293568-38a5cdbdb5cc?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why We're the Best</Subheading>}
        heading="Top E-commerce Development in Al Barsha"
        description="We create online stores that drive results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Custom Solutions",
            description: "Stores built to match your brand.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Rapid Delivery",
            description: "Launch your store in days.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Platform Expertise",
            description: "Mastery in Shopify, WooCommerce, more.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Systems",
            description: "Safe shopping for your customers.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-First",
            description: "Optimized for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Leader",
            description: "Al Barsha’s top-rated developers.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Deliver</Subheading>}
        heading="Our Store Development Process"
        description={
          <Description>
            We craft your e-commerce store with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Strategy: Align with your business vision.</li>
              <li>Design: Create intuitive, engaging storefronts.</li>
              <li>Development: Build with robust integrations.</li>
              <li>Testing: Ensure seamless performance.</li>
              <li>Launch: Deploy your store for success.</li>
              <li>Support: Provide ongoing optimization.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1526406915894-7bcd65f60845?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1609921141835-710b7fa6e438?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="E-commerce Wins in Al Barsha"
        description="Our stores empower businesses."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Surge",
            description: "Increased revenue by 150% in 2 months.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Launch",
            description: "Stores live in under a week.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "97% satisfaction from businesses.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Grow?</Subheading>}
        heading="Best Online Store Developers in Al Barsha"
        description={
          <Description>
            Choose MilaajBrandset, the best online store developers in Al
            Barsha, for cutting-edge e-commerce solutions. Contact us to launch
            your store today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1532363814356-df99100ae399?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1475873326779-3eae1a9c0d13?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
